import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentStatus } from '../models/enum-payment-status';

@Pipe({ name: 'paymentStatus' })
export class PaymentStatusPipe implements PipeTransform {
  transform(id: number, ...args: boolean[]): string {
    switch (id) {
      case enumPaymentStatus.PROCESSING:
        return `<div class="transfer processing"></div>`;
      case enumPaymentStatus.PAYED:
        return `<div class="transfer payed"></div>`;
      case enumPaymentStatus.NOT_PAYED:
        return `<div class="transfer canceled"></div>`;
    }
    return ``
  }
}